module.exports = __webpack_public_path__ + "static/media/closeCircle.4c47fd58.svg";